import getCurrentLocale from './current-locale';
import { RTL_LOCALES } from '@wix/wix-vod-constants/common';

export default () => {
  const locale = getCurrentLocale();
  return RTL_LOCALES.includes(locale);
};
